import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import NumberRating from './NumberRating'

type InheritedNumberRatingProps = Pick<ComponentProps<typeof NumberRating>, 'variant' | 'numberPosition' | 'onlyNumber' | 'inlineLabel' | 'hideLink' | 'link' | 'onReviewSubTitleClick'>

interface Props extends InheritedNumberRatingProps {
  rating: App.OfferRating
}

function OfferRating({ rating, ...numberRatingProps }: Props) {
  const intl = useIntl()
  const fromOnlineReviewsLabel = intl.formatMessage({
    id: 'dcvdamKzJavTEIUDmNnI',
    defaultMessage: 'From online reviews',
    description: 'Subtitle for offer rating sourced from Google reviews',
  })

  return <NumberRating
    {...numberRatingProps}
    rating={rating.score}
    total={rating.reviewsTotal}
    ratingSubtitle={rating.reviewsSource === 'google' ? fromOnlineReviewsLabel : undefined}
  />
}

export default OfferRating
